<template>
  <div>
    <el-button
      type="primary"
      @click="addCLassForStu"
      :size="btnSize"
      :disabled="btnDisable"
       icon="el-icon-edit"
    >
      <slot></slot>
    </el-button>
    <Modal v-model="modalShow" width="470" footer-hide>
      <p slot="header" style="text-align: center; font-size: 15px">
        <Icon type="ios-information-circle"></Icon>
        <!-- <span>
          <slot></slot>
        </span> -->
        <span>课程更新时间</span>

      </p>
      <el-form :inline="true" :model="formStu" label-width="100px">
        <el-form-item label="课程更新时间:">
           <DatePicker
            v-model="formStu.updatedTime"
            type="date"
            :placeholder="updatedTimeShow"
            format="yyyy-MM-dd"
            placement="bottom-end"
          ></DatePicker>
        </el-form-item>
        
      </el-form>
      <Divider />
      <el-button type="primary" @click="modalConfirm" style="margin-left: 266px"
        >确定</el-button
      >
      <el-button type="primary" @click="modalCancel">取消</el-button>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "stUpdated",
  data() {
    return {
      modalShow: false,
      loading: true,
      formStu: {
        updatedTime: "",
      },
      updatedTimeShow:"请填写时间"
    };
  },
  props: {
    btnDisable: {
      type: Boolean,
      default: false,
    },
    btnSize: {
      type: String,
      default: "mini",
    },
    // updatedTime :{
    //   type: String,
    //   default: "",
    // },
     rowDta :{
      type: Object,
      default: "",
    },
    
  },
  created() {
    console.log(this.rowDta)
    this.formStu.updatedTime = this.rowDta.date
    // debugger
  },
  watch: {},
  methods: {
    addCLassForStu() {
      this.modalShow = true;
    },

    modalConfirm() {
      if (this.formStu.updatedTime == "") {
        alert("课程更新时间不能为空");
        return;
      } else {
        //   传值
        this.$emit("stUpdatedResult", {
          updatedTime: this.formStu.updatedTime,
          order:this.rowDta.order,
          courseId:this.rowDta.id
        });

        this.modalShow = false;
      }
    },
    modalCancel() {
      this.modalShow = false;
    },
  },
};
</script>

<style lang="less">
</style>


// WEBPACK FOOTER //
// stUpdated.vue?f72db958